import React, { useState, useEffect } from 'react';
import { Dialog, Typography } from '@mui/material';
import { Container, Button, DialogActions, DialogContent, DialogTitle, TextField  } from "@mui/material";
import { MenuInicial } from "./MenuInicial";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, SUCURSALESLISTAR, SUCURSALACTUALIZAR,SUCURSALACTUALIZARFECHACIERRE } from '../services/apiConfig';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import Cargando from './utils/Cargando.jsx';
import '../App.css'; //Importa tu archivo de estilos
import moment from 'moment';
import { format, parse, compareAsc } from 'date-fns';
import StoreIcon from '@mui/icons-material/Store'; // Asegúrate de tener instalado el paquete de iconos
import { registrarLogError } from '../services/api.js';


import esLocale from 'date-fns/locale/es';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerStyles.css';

function SucursalesList() {
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const usuarioid = userData?.usuarioid;

  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(''); // Agrega esta línea
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isEditDialogOpenFecha, setIsEditDialogOpenFecha] = useState(false);
 
  const [horaDesde, setHoraDesde] = useState('');
  const [horaHasta, setHoraHasta] = useState('');
  const [horaDesdeST, setHoraDesdeST] = useState('');
  const [horaHastaST, setHoraHastaST] = useState('');
  const [nombreSucursal, setNombreSucursal] = useState('');

  const [cierreFechaInicio, setcierreFechaInicio] = useState('');
  const [cierreFechaFin, setcierreFechaFin] = useState('');
  const [diasNoAbre, setDiasNoAbre] = useState([]);

  
  useEffect(() => {
   /* const loggedIn = sessionStorage.getItem("loggedIn");
    if (!loggedIn) {
      navigate("/login");
    }*/
    //const diasNoAbreBackend = "lunes;martes;jueves"; // Ejemplo de cadena recibida

    // Convertir la cadena en un array de días
    //const diasArray = diasNoAbreBackend.split(';');

    // Establecer el estado de los días que no abre la sucursal
    //setDiasNoAbre(diasArray);

    fetchSucursales(); // Llamada a la función para cargar las sucursales

  }, []);


  const diasSemana = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'];

  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'nombre', headerName: 'Nombre', width: 200 },
    { field: 'direccion', headerName: 'Direccion', width: 100 },
    { field: 'mail', headerName: 'Mail', width: 200 },
    { field: 'horainiciopt', headerName: 'Inicio PT', width: 75, cellClassName: 'timeField' },
    { field: 'horafinpt', headerName: 'Fin PT', width: 75, cellClassName: 'timeField' },
    { field: 'horainiciost', headerName: 'Inicio ST', width: 75, cellClassName: 'timeField' },
    { field: 'horafinst', headerName: 'Fin ST', width: 75, cellClassName: 'timeField' },
    
    { field: 'dias_no_abre', headerName: 'Dias cerrado', width: 200 },
  
    { field: 'activo', headerName: 'Activo', width: 50,  cellClassName: (params) => (params.value ? 'boolFieldTrue' : 'boolFieldFalse'),
      renderCell: (params) => (<div>{params.value ? 'Sí' : 'No'}</div>), },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 200,
      renderCell: (params) => (
        <div>
          <Button onClick={() => handleEdit(params.row)}>Horarios</Button>
          <Button onClick={() => handleCerrar(params.row)}>Cerrar sucursal</Button>
      </div>
      ),
    },
  ];


  moment.locale('es'); // Establecer el idioma en español


  

  const handleEdit = (user) => {
    setSelectedUser(user);
    setHoraDesde(user.horainiciopt || '');
    setHoraHasta(user.horafinpt || '');
    setHoraDesdeST(user.horainiciost || '');
    setHoraHastaST(user.horafinst || '');
    setNombreSucursal(user.nombre|| '');
    setIsEditDialogOpen(true);
  };

  const handleCerrar = (user) => {
    setErrorMessage('');
    setcierreFechaInicio(user.cierrefechainicio ? moment(user.cierrefechainicio).toDate() : null);
    setcierreFechaFin(user.cierrefechafin ? moment(user.cierrefechafin).toDate() : null);
    setSelectedUser(user);
    setNombreSucursal(user.nombre || '');
    const diasNoAbreArray = user.dias_no_abre ? user.dias_no_abre.split(';') : [];
    setDiasNoAbre(diasNoAbreArray);
    setIsEditDialogOpenFecha(true);
  };
  
  const handleDateChangeDesde = (date) => {
    setcierreFechaInicio(date);
    console.log("la fecha inicio a "+date);
  };

  const handleDateChangeHasta = (date) => {
    setcierreFechaFin(date);
    console.log("la fecha fin a "+date);
  };

  const handleSaveEdit = () => {
    // Validar que ambos campos de horario estén completos
    if (!horaDesde || !horaHasta) {
      setErrorMessage('Por favor, completa ambos campos de horario.');
      return;
    }

    if (!horaDesdeST || !horaHastaST) {
      setErrorMessage('Por favor, completa ambos campos de horario del segundo turno.');
      return;
    }

    const updatedUserData = {
      id: selectedUser.id,
      horainiciopt: horaDesde,
      horafinpt : horaHasta,
      horainiciost : horaDesdeST,
      horafinst : horaHastaST,
    };

    axios.post(API_BASE_URL + SUCURSALACTUALIZAR, updatedUserData)
    .then((response) => {
    console.log(response.status);
    if (response.status === 200) {
      
      fetchSucursales(); // Llamada a la función para cargar las sucursales

      setIsEditDialogOpen(false);
    } else {
      setErrorMessage('Error al guardar los datos. Código de estado: ' + response.status);
      registrarLogError(usuarioid, 'Sucursales', response.status); // Debes reemplazar 'App Nombre' por el nombre de tu aplicación
    }
  })
  .catch((error) => {
    setErrorMessage('Error al realizar la solicitud: ' + error.message);
    registrarLogError(usuarioid, 'Sucursales',  JSON.stringify(error)); // Debes reemplazar 'App Nombre' por el nombre de tu aplicación
  });

    //setIsEditDialogOpen(false);
  };

  const handleDiaCierreChange = (dia, isChecked) => {
    const updatedDiasNoAbre = isChecked
    ? [...diasNoAbre, dia] // Agrega el día si está marcado
    : diasNoAbre.filter((d) => d !== dia); // Quita el día si no está marcado
    //setDiasCierre({ ...diasCierre, [dia]: e.target.checked })
    setDiasNoAbre(updatedDiasNoAbre);
  };

  const handleSaveEditCierre = () => {
    
    var fechacierredesde = cierreFechaInicio ? format(new Date(cierreFechaInicio), 'yyyy-MM-dd') : null;
    var fechacierrehasta = cierreFechaFin ? format(new Date(cierreFechaFin), 'yyyy-MM-dd') : null;
    // Obtener los días seleccionados
    
    ///validaciones

    if ((fechacierredesde && fechacierrehasta) || (!fechacierredesde && !fechacierrehasta)) {
      // Ambas fechas tienen valor o ambas son null

      if (fechacierredesde && fechacierrehasta) {
        // Ambas fechas tienen valor

        // Compara las fechas
        const comparacion = compareAsc(new Date(fechacierredesde), new Date(fechacierrehasta));

        if (comparacion === 1) {
          // La fecha desde es mayor que la fecha hasta
          console.log('La fecha desde debe ser menor o igual a la fecha hasta');
          setErrorMessage('La fecha desde debe ser menor o igual a la fecha hasta');
          return;
        } else {
          // Las fechas son válidas
          console.log('Las fechas son válidas');
        }
      } else {
        // Ambas fechas son null, lo cual también es válido
        console.log('Las fechas son válidas');
      }
    } else {
      // Si una tiene valor y la otra no, muestra un mensaje de error
      console.log('Ambas fechas deben tener un valor o ambas deben ser null');
      setErrorMessage('Ambas fechas deben tener un valor o ambas deben ser vacias');
      return;
    }
    /*if (diasNoAbre.length === 0) {
      setErrorMessage('Selecciona al menos un día de cierre.');
      return;
    }
*/
    const diasSeleccionadosNoAbre = diasNoAbre.join(';');
    console.log("los dias son "+diasSeleccionadosNoAbre);
    const updatedUserData = {
      id: selectedUser.id,
      cierrefechaincio: cierreFechaInicio,
      cierrefechafin : cierreFechaFin,
      dias_no_abre: diasSeleccionadosNoAbre,
    };

    axios.post(API_BASE_URL + SUCURSALACTUALIZARFECHACIERRE, updatedUserData)
  .then((response) => {
    console.log(response.status);
    if (response.status === 200) {
      //console.log('Datos guardados exitosamente:', response.data);
      fetchSucursales(); // Llamada a la función para cargar las sucursales

      setIsEditDialogOpenFecha(false);
    } else {
      //console.error('Error al guardar los datos. Código de estado:', response.status);
      // Aquí puedes manejar el error de acuerdo a tus necesidades
      setErrorMessage('Error al guardar los datos. Código de estado: ' + response.status);
    }
  })
  .catch((error) => {
    //console.error('Error al realizar la solicitud:', error);
    setErrorMessage('Error al realizar la solicitud: ' + error.message);
    // Aquí puedes manejar el error de acuerdo a tus necesidades
  });

    //setIsEditDialogOpen(false);
  };

  const fetchSucursales = () => {
    axios.get(API_BASE_URL + SUCURSALESLISTAR)
      .then((response) => {
        setUsers(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error al cargar los usuarios', error);
        setLoading(false);
      });
  };





  return (
    <div>
      <Container>
        <MenuInicial></MenuInicial>
        <div className='miDiv'><h2>Sucursales</h2></div>
        <div>
          {loading ? (
            <Cargando></Cargando>
          ) : (
            <DataGrid rows={users} columns={columns} />
          )}
        </div>
      </Container>

      <div style={{ height: '90%', width: '100%' }}>
        <Dialog open={isEditDialogOpen} onClose={() => setIsEditDialogOpen(false)}>
          <DialogTitle>Editar Horario Sucursal {nombreSucursal}</DialogTitle>
          <DialogContent>
           
          <div className='miDiv'>
              <Typography variant="h6">Primer Turno</Typography>
            </div>
            <div className='miDiv' style={{ display: 'flex', gap: '16px' }}>
              <TextField
                label="Desde"
                type="time"
                value={horaDesde}
                onChange={(e) => setHoraDesde(e.target.value)}
              />
              <TextField
                label="Hasta"
                type="time"
                value={horaHasta}
                onChange={(e) => setHoraHasta(e.target.value)}
              />
            </div>

            <div className='miDiv'>
              <Typography variant="h6">Segundo Turno</Typography>
            </div>
            <div className='miDiv' style={{ display: 'flex', gap: '16px' }}>
              <TextField
                label="Desde"
                type="time"
                value={horaDesdeST}
                onChange={(e) => setHoraDesdeST(e.target.value)}
              />
              <TextField
                label="Hasta"
                type="time"
                value={horaHastaST}
                onChange={(e) => setHoraHastaST(e.target.value)}
              />
            </div>

             {/* Muestra el mensaje de error en tu formulario */}
             {errorMessage && (
              <div style={{ color: 'red', marginTop: '10px' }}>
                {errorMessage}
              </div>
            )}


          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={() => setIsEditDialogOpen(false)} color="error">
              Cancelar
            </Button>
            <Button variant="contained" onClick={handleSaveEdit} color="primary">
              Guardar
            </Button>
          </DialogActions>
        </Dialog>
      </div>



      <div style={{ height: '100%', width: '100%' }}>
        <Dialog open={isEditDialogOpenFecha} onClose={() => setIsEditDialogOpenFecha(false)}>
          <DialogTitle>
            <StoreIcon style={{ marginRight: '8px' }} />Editar Fecha Cierre Sucursal {nombreSucursal}
          </DialogTitle>
          <DialogContent>
            <div className=''>
              <Typography variant="h6"></Typography>
            </div>
            <div className='' style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
             {/*}   
                <div className='miDiv'>
                  <DatePicker
                    selected={cierreFechaInicio}
                    onChange={date => handleDateChangeDesde(date)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Fecha de Cierre desde"
                    locale={esLocale}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={5}
                    showMonthDropdown
                    scrollableMonthYearDropdown
                    dropdownMode="select"
                    isClearable={true}
                    className="custom-datepicker" // Clase para tus estilos personalizados
                  
                  />
              </div>

             
              <div className='miDiv'>
                  <DatePicker
                    selected={cierreFechaFin}
                    onChange={date => handleDateChangeHasta(date)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="hasta"
                    locale={esLocale}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={5}
                    showMonthDropdown
                    scrollableMonthYearDropdown
                    dropdownMode="select"
                    isClearable={true}
                    className="custom-datepicker" // Clase para tus estilos personalizados
                    
                  />
              </div>
          */}
              <div className='miDiv'>
        <Typography variant="h6">Seleccione los días de cierre</Typography>
      </div>
        <div className='' style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {diasSemana.map((dia) => (
            <div key={dia}>
              <input
                type="checkbox"
               
                
                checked={diasNoAbre.includes(dia)}
                onChange={(e) => handleDiaCierreChange(dia, e.target.checked)} // Usamos handleDiaCierreChange
              
              />
              <label>{dia.charAt(0).toUpperCase() + dia.slice(1)}</label>
            </div>
          ))}
        </div>


           
              </div>
              {/* Muestra el mensaje de error en tu formulario */}
              {errorMessage && (
                <div style={{ color: 'red', marginTop: '10px' }}>
                  {errorMessage}
                </div>
              )}
            </div>
      

      
        </DialogContent>

          <div className='miDiv'>
          <DialogActions>
            
            <Button variant="contained" onClick={() => setIsEditDialogOpenFecha(false)} color="error">
              Cancelar
            </Button>

            <Button variant="contained" onClick={handleSaveEditCierre} color="primary">
              Guardar
            </Button>


          </DialogActions>
          </div>
        </Dialog>
      </div>

    </div>
  );
}

export default SucursalesList;
